// CandidatesZone, German. The candidate vocabulary lives here and not in the People catalogue
// because the zone is on the People page AND the Campaigns page; identical values to
// PeoplePage's own entries, so whichever registers first, nothing is lost.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Candidates': 'Kandidaten',
  'named by evidence, not on the record · promote or refuse in Review':
    'durch Belege benannt, nicht im Bestand · in der Prüfung übernehmen oder ablehnen',
  'Review': 'Prüfung',
  'loading…': 'wird geladen…',
  'The candidates could not be read: {error}': 'Die Kandidaten konnten nicht gelesen werden: {error}',
  'not on the record': 'nicht im Bestand',
  'from the segment {name}': 'aus dem Segment {name}',
  'as Surfe returned it': 'wie von Surfe zurückgegeben',
  'no source named': 'keine Quelle genannt',
  'Promote to person': 'Zur Person machen',
  'Holds {ref} and writes the row': 'Übernimmt {ref} und schreibt die Zeile',
  'No proposal behind this row — its status is flipped directly':
    'Hinter dieser Zeile steht kein Vorschlag — ihr Status wird direkt umgestellt',
  'No candidate matches the search. {n} are waiting.':
    'Kein Kandidat passt zur Suche. {n} warten.',
  'Nothing has proposed itself as a person. Candidates arrive from a lookalike run or a registry publication, and they stay off the record until you promote one.':
    'Nichts hat sich als Person vorgeschlagen. Kandidaten entstehen aus einem Lookalike-Lauf oder einer Registerpublikation und bleiben ausserhalb des Bestands, bis Sie einen übernehmen.',
  '{name} is on the record. {ref} is held.': '{name} steht im Bestand. {ref} ist übernommen.',
  '{name} is on the record.': '{name} steht im Bestand.',
  'Could not promote this candidate.': 'Dieser Kandidat konnte nicht übernommen werden.',

  // ── the source column ──
  'Source': 'Quelle',
  // 'research' alone already means the VERB (WhyNow's next move); the source column names a
  // producer, so it carries its own context key and the two never overwrite each other.
  'research‖source': 'Recherche',
  'a lookalike run against this segment persona named them':
    'ein Lookalike-Lauf zu dieser Segment-Persona hat sie genannt',
  'the principal that filed the proposal': 'die Instanz, die den Vorschlag abgelegt hat',
}, 'CandidatesZone');
